import { render, staticRenderFns } from "./reportPurchase.vue?vue&type=template&id=674a415a&scoped=true"
import script from "./reportPurchase.vue?vue&type=script&lang=js"
export * from "./reportPurchase.vue?vue&type=script&lang=js"
import style0 from "./reportPurchase.vue?vue&type=style&index=0&id=674a415a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a415a",
  null
  
)

export default component.exports